import { AxiosResponse } from 'axios';
import { backendApiInstance } from './backendApiInstance';

export async function getOrganizationById(organizationId: string): Promise<AxiosResponse> {
  return backendApiInstance.get(`/organizational-data/${organizationId}`);
}

export async function getOrganizationsList(): Promise<AxiosResponse> {
  return backendApiInstance.get('organizational-data/list');
}

export async function getOrganizationSubscription(): Promise<AxiosResponse> {
  return backendApiInstance.post('organizational-data/get-organization-subscription');
}

export async function updateOrganizationSubscription(organizationId: string, data: any): Promise<AxiosResponse> {
  return backendApiInstance.patch(`/organizational-data/organization-subscription/${organizationId}`, data);
}
